import React, { useState, useEffect } from "react";
import { List, Map, is, fromJS } from "immutable";

function parseJsonString(str, filterFct) {
  let obj;
  try {
    obj = fromJS(JSON.parse(str)).filter(filterFct ? filterFct : x => true);
    console.log("parseJsonString " + obj);
  } catch (e) {
    return null;
  }
  return obj;
}

function setNewJson(newJson, onSet, filterFct) {
  if (!newJson) return;
  let parsed = parseJsonString(newJson, filterFct);
  console.log("setNewJson " + JSON.stringify(parsed));
  if (parsed) {
    onSet(parsed);
  }
}

const CompJsonEdit = ({ json, onSet, filterFct }) => {
  const [editedJson, setEditedJson] = useState(json);

  return (
    <div>
      <textarea
        type="text"
        value={editedJson}
        onChange={e => setEditedJson(e.target.value)}
      />
      <button
        onClick={e => {
          e.stopPropagation();
          setNewJson(editedJson, onSet, filterFct);
        }}
      >
        Set
      </button>
    </div>
  );
};
export default CompJsonEdit;



// WEBPACK FOOTER //
// ./src/components/CompJsonEdit.js